import { render, staticRenderFns } from "./RowChildToggle.vue?vue&type=template&id=52a5afa4&scoped=true&"
import script from "./RowChildToggle.vue?vue&type=script&lang=js&"
export * from "./RowChildToggle.vue?vue&type=script&lang=js&"
import style0 from "./RowChildToggle.vue?vue&type=style&index=0&id=52a5afa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5afa4",
  null
  
)

export default component.exports